const Renderif = ({children, isTrue}) => {
    return isTrue ? children :null
} 
export default Renderif;